import { environment } from "../../../environments/environment";

// En modo desarrollo, podemos necesitar la ruta para pruebas
export const BASE = environment.production ? 'seguros/hogar/arriendo/cotizador' : '';

function buildPathFinalPage(path: string): string {
  return BASE ? `${BASE}/final_page/${path}` : `final_page/${path}`;
}

// Paginas finales constantes

export const ERROR_500 = 'error_500';


//Páginas Finales Redirect

export const ERROR_500_REDIRECT = buildPathFinalPage('error_500');